import React, { useState, useEffect, useRef } from 'react';

import { reqGET, content_language, translate } from '../../../../Utils';

import * as Hosts from "../../../../Hosts";

import { language } from '../Language';

import parse from 'html-react-parser';

import { Navigation, Pagination, Autoplay, Scrollbar, A11y, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import "swiper/swiper-bundle.min.css";

import Modal from "../../Forms/OpinionModal";

import Loader from '../../../../loader';

// import "../../Pagina.css";
import "./HomeTestimonies_01.css"

const HomeTestimonies = (props) => {

	const [, set_dados] = useState(null)
    const testimonies_list = useRef([])
	const dados_config = useRef([])
    const [testimonies_title, set_testimonies_title] = useState('')
    const [testimonies_subtitle, set_testimonies_subtitle] = useState('')

    const [show, setShow] = useState(false);

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [/*lang_id*/, set_lang_id] = useState('1');


    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'testemony' && el.info.active) {
                    set_testimonies_title(translate(el.info.title, lang))
                    set_testimonies_subtitle(translate(el.info.subtitle, lang))
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        let getTestimonies = async () => {
            reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/testimony/accepted`)
                .then(res => {
                    set_dados(testimonies_list.current = res.data.filter(v => v.info.status === 'accepted'))
                    setLoading(false)

                }).catch(erro => console.log('Erro testemunhos', erro))
        }
        getTestimonies()

    }, [props, lang])

    return (
        isloading ?
            <Loader />
		:
            <section id="hometestimonies_01" className='div-component'>
                <div className="container">
                    <div className="row">
                        <div className="col-12 title-properties">
                            {
                                testimonies_title !== '' ?
                                    <h3 className="titulo-pp">
                                        {testimonies_title}
                                    </h3>
                                :
                                    null
                            }
                            {
                                testimonies_subtitle !== '' ?
                                    <h4 className={"subtitulo-pp"}>
                                        {testimonies_subtitle}
                                    </h4>
                                :
                                    null
                            }
                            <hr></hr>
                        </div>
                        {
                            testimonies_list.current !== undefined && testimonies_list.current !== null && testimonies_list.current.length > 0 ?
                                <div className="col-12 col-md-9 mx-auto text-center">
                                    <div className="swiper swiper-container swiper-testemunhos">
                                        <Swiper
                                            modules={[Autoplay, Navigation, EffectFade, Pagination, Scrollbar, A11y]}

                                            speed={8000}
                                            loop={testimonies_list.current.length > 1 ? true : false}
                                            autoplay={{
                                                delay: 5000,
                                                disableOnInteraction: false,
                                            }}

                                            spaceBetween={0}
                                            //centeredSlides={true}
                                            //centerInsufficientSlides={true}
                                            slidesPerView={1}
                                            //navigation
                                            pagination={{
                                                el: '.swiper-pagination-testemunhos',
                                                clickable: true
                                            }}
                                            breakpoints={{
                                                // when window width is >= 0px
                                                /*0: {
                                                    slidesPerView: 1,
                                                },*/
                                                // when window width is >= 768px
                                                768: {
                                                    slidesPerView: 1,
                                                },
                                                992: {
                                                    slidesPerView: 1,
                                                },
                                            }}
                                        //scrollbar={{ draggable: true }}
                                        >
                                            {
                                                testimonies_list.current.map((v, key) => {
                                                    return (
                                                        <SwiperSlide key={key} className='p-3'>
                                                            {/*<img src={repo_site_assets_link("aspas.svg")} alt={language[lang].testimonials} title={language[lang].testimonials} className="img-fluid mb-4" />*/}
                                                            <div className="testimonial-text">
                                                                {parse(v.content[0].message)}
                                                            </div>
                                                            <div className='testimonial-title'>
                                                                {parse(v.content[0].name)}
                                                            {
                                                                v.content[0].address !== '' ?
                                                                    <>
                                                                    &nbsp;&#45;&nbsp;
                                                                    {parse(v.content[0].address)}
                                                                    </>
                                                                : null
                                                            }
                                                            </div>
                                                            <div className="testimonial-timestamp">
                                                                {/*v.info.date.creation.split('T')[0]*/}
                                                                {new Date(v.info.date.creation).toLocaleDateString([], { day: "numeric", month: "long", year: "numeric" })}
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                })
                                            }
                                        </Swiper>
                                    </div>
                                    <div className="swiper-pagination-testemunhos mt-2"></div>
                                    <div className="col-12 mt-4 text-center">
                                        <button type="button" /*onClick={() => setShow(true)}*/ data-bs-toggle="modal" data-bs-target={"#opinion_modal_form"} className="btn btn-secondary">{language[lang].testimonials_button_message}</button>
                                        <Modal onClose={() => setShow(false)} show={show} dados_config={dados_config.current} />
                                    </div>
                                </div>
                            :
                                null 
                        }
                    </div>
                </div>
            </section>
    )
};
export default HomeTestimonies;